export const dbDefaultName = 'global_cache';
export const dbDefaultVersion = 1;
